// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
/* Styles */
import './assets/styles/spectre.min.css'
import './assets/styles/spectre-exp.min.css'
import './assets/styles/spectre-icons.min.css'
import 'whatwg-fetch'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js